import { Component, OnInit, Input } from '@angular/core';
import { DocumentsService } from '../documents.service'; // #RPT: replace this something helpful
import { NotificationsService } from '../notifications.service';
import { SearchService } from '../search.service';
import { Observable } from 'rxjs/Observable';


@Component({
  selector: 'app-topmenu',
  templateUrl: './topmenu.component.html',
  styleUrls: ['./topmenu.component.css'],
  providers: [DocumentsService, NotificationsService, SearchService],
})


export class TopmenuComponent implements OnInit {
	searchQuery = '';
	searchResults: Observable<[{}]>;
	docCategories = []; // #RPT: replace this with something helpful
	latestNotifications = [];
	// loggedIn: boolean = false;
	@Input() loggedIn: any = false;

	constructor(
		private documentsService: DocumentsService, // #RPT: replace this something helpful
		private notificationsService: NotificationsService,
		private searchService: SearchService,
	) {
	}
	logSearchResults() {
		// console.log( this.searchResults );
	}
	getDocCategories() { // #RPT: replace this with something helpful
		this.documentsService
			.getDocCategories()
			.subscribe( docCats => this.docCategories = docCats );
	}
	getLatestNotifications() {
		this.notificationsService
			.getLatest()
			.subscribe( notifications => this.latestNotifications = notifications );
	}
	search( searchQuery: string, event: KeyboardEvent ) {
		this.searchQuery = searchQuery;
		this.searchResults = this.searchService.search( this.searchQuery );
	}
	ngOnInit() {
		// this.getDocCategories(); // #RPT: replace this something helpful
		// this.getLatestNotifications();
	}
}


// WEBPACK FOOTER //
// ./src/app/topmenu/topmenu.component.ts